import React from "react";
import { CommandBarButton, IconButton, Link, SelectionMode } from "@fluentui/react";
import DetailsTable from "../../../Table/DetailsTable";
import FeatureSummary from "../../../Util/FeatureSummary";

const StepTable = ({
    steps,
    setSelectedStep,
    cloneOnClick,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick
}) => {
    const columns = [
        {
            key: 'column1',
            name: 'ID',
            fieldName: 'crsStepID',
            minWidth: 50,
            maxWidth: 50,
            isMultiline: false,
        },
        {
            key: 'column2',
            name: 'Step Title',
            fieldName: 'crsStepTitle',
            minWidth: 200,
            maxWidth: 200,
            isMultiline: false,
        },
        {
            key: "menu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    cloneOnClick={() => { cloneOnClick(item.crsStepID)}}
                    deleteOnClick={deleteOnClick}
                    id={item.crsStepID}
                    item={item}
                />
            )
        },
        {
            key: 'column3',
            name: 'Primary Course',
            fieldName: 'crsTitle',
            minWidth: 200,
            maxWidth: 200,
            onRender: (item) => <Link href={`/course-feature/courses/${item.crsid}/${item.crsRevID}/wizard`}>{item.crsTitle}</Link>,
            isMultiline: false,
        },
        {
            key: 'column4',
            name: 'Step Type',
            fieldName: 'crsStepType',
            minWidth: 100,
            maxWidth: 100,
            isMultiline: false,
        },
        {
            key: 'column5',
            name: 'Status',
            fieldName: 'pubStatus',
            minWidth: 100,
            maxWidth: 100,
            isMultiline: false,
        },
        {
            key: 'column6',
            name: 'Last Updated',
            fieldName: 'lastUpdatedDate',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item) => (item.lastUpdatedDate ? new Date(item.lastUpdatedDate).toLocaleDateString() : ''),
            isMultiline: false,
        },
    ];
    

    const items = steps ?? [];

    const selectionHook = (items) => {
        setSelectedStep(items && items[0]);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={"crsStepTitle"}
                detailsListProps={{ selectionMode: SelectionMode.none}}
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Create Step"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Course Steps"
                summary="This table displays all course steps, including their title, type, status, and last updated date. You can add, edit, clone, or delete steps. This feature allows admins to edit and add steps available for use in a course."
                imageUrlPath="courses2"
            />
        </>
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    cloneOnClick,
    deleteOnClick,
    id,
    item,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "print",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => {
                    deleteOnClick(item)
                },
            },
            {
                key: "Clone",
                iconProps: { iconName: "Copy" },
                text: "Clone",
                onClick: () => cloneOnClick(id),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default StepTable;
